export default __webpack_public_path__ + "static/media/support.2e79c974.png";